export const AUTH_INIT = 'AUTH_INIT'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
